import EmailInvitePage from './EmailInvitePage.jsx';
import EmailApprovePage from './EmailApprovePage.jsx';

export {EmailInvitePage, EmailApprovePage}


// WEBPACK FOOTER //
// ./pages/fair/fair-emails/index.js